import {
  GET_MAP_PLATES_ERROR,
  GET_MAP_PLATES_REQUEST,
  GET_MAP_PLATES_SUCCESS,
  DELETE_MAP_PLATE_REQUEST,
  DELETE_MAP_PLATE_SUCCESS,
  DELETE_MAP_PLATE_ERROR,
  CREATE_MAP_PLATE_REQUEST,
  CREATE_MAP_PLATE_SUCCESS,
  CREATE_MAP_PLATE_ERROR,
  GET_PLATE_SUGGESTIONS_REQUEST,
  GET_PLATE_SUGGESTIONS_SUCCESS,
  GET_PLATE_SUGGESTIONS_ERROR,
  GET_MAP_PLATES_PROGRESS,
} from 'redux/actions';

const initialState = {
  loading: false,
  plateSuggestionsLoading: false,
  deleteLoading: false,
  createLoading: false,

  mapPlates: [],
  plateSuggestions: [],

  paginationMeta: null,
  paginationLinks: null,

  message: null,

  success: false,
  createSuccess: false,

  progress: 0,
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_MAP_PLATES_REQUEST:
      return {
        ...state,
        loading: true,
        message: null,
        success: false,
      };

    case GET_MAP_PLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        mapPlates: action.payload.plates,
        paginationMeta: action.payload.meta,
        paginationLinks: action.payload.links,
        success: action.payload.success,
      };

    case GET_MAP_PLATES_ERROR:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        success: false,
      };

    case GET_PLATE_SUGGESTIONS_REQUEST:
      return {
        ...state,
        plateSuggestionsLoading: true,
      };

    case GET_PLATE_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        plateSuggestionsLoading: false,
        plateSuggestions: action.payload.plateSuggestions,
      };

    case GET_PLATE_SUGGESTIONS_ERROR:
      return {
        ...state,
        plateSuggestionsLoading: false,
        message: action.payload.message,
      };

    case CREATE_MAP_PLATE_REQUEST:
      return {
        ...state,
        createLoading: true,
        createSuccess: false,
      };

    case CREATE_MAP_PLATE_SUCCESS:
      return {
        ...state,
        createLoading: false,
        createSuccess: true,
        success: action.payload.success,

        mapPlates: [...state.mapPlates, action.payload.plate],
      };

    case CREATE_MAP_PLATE_ERROR:
      return {
        ...state,
        createLoading: false,
        createSuccess: false,
        message: action.payload.message,
      };

    case DELETE_MAP_PLATE_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        message: null,
      };

    case DELETE_MAP_PLATE_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        success: action.payload.success,
        message: action.payload.message,

        mapPlates: state.mapPlates.filter(
          (plate) => plate.id !== action.payload.id
        ),
      };

    case DELETE_MAP_PLATE_ERROR:
      return {
        ...state,
        deleteLoading: false,
        message: action.payload.message,
      };

    case GET_MAP_PLATES_PROGRESS:
      return {
        ...state,
        progress: action.payload.progress,
      };

    default:
      return state;
  }
}
